export class ErrorLS {
    public timestamp: string;
    public type: string;
    public msg: string;
}

export class ErrorTypes {
    public static readonly WARNING: string = 'WARNING';
    public static readonly ERROR: string = 'ERROR';
}
